import '../../App.css';
import './start-chapter.css'
//import {TabsHero} from '../../component/servicetab'
import { Accordion } from '../../component/accordion2';
export const StartChapter = () => {
    const faqItems = [
        {
          title: 'What is the chapter structure?',
          content: 'Each ACE Chapter consists of a structure of Presidents, Vice Presidents, Subject Officers, and Class Representatives. The role of the presidents and vice presidents are to oversee operations and ensure material is being made along with holding successful study sessions. Subject officers are in charge of overseeing the courses under a specific subject. For example, the math subject officer would oversee subjects from Algebra 1 to AP Calculus BC. Subject officers ensure representatives make material on-time and help representatives make reviews. Class representatives are in charge of making the material for their assigned subjects, such as through making a slideshow review or practice test. They will also hold and lead study sessions for others to attend.',
        },
        {
          title: 'How are things done?',
          content: 'ACE is an educational nonprofit that prides itself on having chapters that create targeted study material for other students. In an ACE Chapter, the goal is to get as many students access to study materials. These study materials include practice tests uploaded on the ACE website, slideshows, and other review material. By doing this, you will be making an impact just like the other ACE Chapters! Additionally when creating material, ACE prides itself on academic integrity. Ensure that all material is original and verify practice tests and material with teachers to ensure correct information.',
        },
        {
            title:'How do I run an ACE Chapter?',
            content: 'By creating a chapter, you have numerous roles need to be filled. Open up an application form for leadership positions, officer positions, and representative positions and select a team. Then, assign the roles correspondingly. To run a chapter successfully, ensure tasks are being delegated and roles are being performed properly. Additionally, promote study sessions and get other students to join and engage with the material to grow the impact of your chapter.'
        }
      ]
    
    return(
        <div>
            <main className="container py-8 px-4 mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-8">
          Chapter <span className="text-[#E94B35]">Information</span>
        </h1>
        <p>Do you want to join the academic community of ACE? Let's start with you!</p>
            <p>If you would like to open a chapter, please complete the following form by clicking <a href="https://forms.gle/Edr4fRU8mwSn494M8" target="/blank" className="hype">here</a> or scroll down to fill out the form!</p>
            <div className="rounded-xl bg-[#1a1a1a] overflow-hidden w-1/2 mx-auto">

            <Accordion
      items={faqItems}
    />
</div>

      </main>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSe4y_aC-tED45xGPN4TGTH2habhko20OGwQr7c-Zt8hQQ0MGQ/viewform?embedded=true" width={640} height={500} frameBorder={0} marginHeight={0} marginWidth={0} title="aceform">Loading…</iframe>
            <br />
        </div>
    );
}